/**
 * 公共api
 */
export default {
  //登录
  login: "/userLogin/login",
  // 上传文档/图片
  uploadFile: "/attachment/uploadFile",
  //获取短信验证码
  SMSCode: "/userLogin/SMSCode",
  //提交短信验证码
  CheckSMSCode: "/userLogin/CheckSMSCode",
  //修改密码
  retrievePassword: "/userLogin/retrievePassword",
}
